const ROLES_FOR_APP = {
    DASHBOARD_VIEW: "view",

    ADVERTISER_AGENCY: 'advertiser_agency',
    MEDIA_AGENCY: 'media_agency',
    ADVERTISER_AGENCY_REPORT: 'advertiser_agency_report',
};

const isHavePermissionRole = (keyRoles: string | string[], permissions: { id: string | number, name: string }[] = []): boolean => {
    const roles = typeof keyRoles === 'string' ? [keyRoles] : keyRoles;
    return true; // permissions?.some(item => roles?.includes(item.name));
};

export { ROLES_FOR_APP, isHavePermissionRole };